// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"946d4f96","717":"946d4f96"}[chunkId] + ".chunk.css";
};